function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import { Button, Form, FormGroup, FormFeedback, Label, Input, InputGroup, InputGroupAddon, InputGroupText, CustomInput, Modal, ModalHeader, ModalBody, ModalFooter, Popover, PopoverHeader, PopoverBody } from 'reactstrap';
import { Card, CardTitle, CardText, CardBody, Row, Col, Container } from 'reactstrap';

import BlockUi from 'react-block-ui';
import { Loader, Types } from 'react-loaders';
import 'react-block-ui/style.css';
import 'loaders.css/loaders.min.css';
import './loaders.css';

var logdown = require('logdown');
var console = logdown('rx-core-block', { prefixColor: '#d84315' });

export var RXBlockStatus = {
    HIDE: 0,
    LOAD: 1,
    SUCCESS: 2,
    ERROR: 3
};

export var RXBlockColor = {
    PRIMARY: '#20a8d8',
    SECONDARY: '#c8ced3',
    SUCCESS: '#4dbd74',
    INFO: '#63c2de',
    WARNING: '#ffc107',
    DANGER: '#f86c6b',
    LIGHT: '#f0f3f5',
    DARK: '#2f353a'
};

export var RXBlock = function (_Component) {
    _inherits(RXBlock, _Component);

    function RXBlock(props) {
        _classCallCheck(this, RXBlock);

        var _this = _possibleConstructorReturn(this, _Component.call(this, props));

        _this.state = {
            blocking: false,
            blockingMessage: '',
            blockingColor: RXBlockColor.PRIMARY,
            blockingClass: 'block-transparency',
            blockingLoaderClass: 'text-primary',
            blockingLoaderActive: true
        };

        if (_this.props.color !== undefined) {
            _this.state.blockingColor = _this.props.color;
        }

        if (_this.props.message != undefined) {
            _this.state.blockingMessage = _this.props.message;
        }
        return _this;
    }

    RXBlock.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
        var _this2 = this;

        if (this.props.status != prevProps.status) {
            console.log('\xECn component will received status props with: ' + JSON.stringify(this.props.status));
            switch (this.props.status) {
                case RXBlockStatus.HIDE:
                    this.setState({ blocking: false });
                    break;
                case RXBlockStatus.LOAD:
                    this.setState({ blocking: true, blockingColor: this.props.color });
                    break;
                case RXBlockStatus.SUCCESS:
                    this.setState({ blocking: false });
                    break;
                case RXBlockStatus.ERROR:
                    this.setState({ blockingColor: RXBlockColor.DANGER });
                    setTimeout(function () {
                        _this2.setState({ blocking: false });
                    }, 2000);
                default:
                    break;
            }
        }
        if (this.props.color != prevProps.color) {
            console.log('\xECn component will received color props with: ' + JSON.stringify(this.props.color));
            this.setState({ blockingColor: this.props.color });
        }
        if (this.props.message != prevProps.message) {
            console.log('\xECn component will received message props with: ' + JSON.stringify(this.props.message));
            this.setState({ blockingMessage: this.props.message });
        }
    };

    RXBlock.prototype.render = function render() {
        return React.createElement(
            BlockUi,
            {
                tag: 'div',
                className: this.state.blockingClass,
                blocking: this.state.blocking,
                message: React.createElement(
                    'div',
                    { style: { color: this.state.blockingColor } },
                    this.state.blockingMessage
                ),
                loader: React.createElement(Loader, { active: this.state.blockingLoaderActive, type: 'line-scale-pulse-out', color: this.state.blockingColor, className: this.state.blockingLoaderClass })
            },
            this.props.children
        );
    };

    return RXBlock;
}(Component);

// module.exports = {
//     RXBlock: RXBlock,
//     RXBlockStatus: RXBlockStatus,
//     RXBlockColor: RXBlockColor
// };